
import Vue from 'vue'

const getIsCookiesToAccept = (): boolean => {
  const storedValue = localStorage.getItem('isCookiesAccepted');
  if (storedValue === null) {
    localStorage.setItem('isCookiesAccepted', 'false');
    return true
  } else {
    return !(storedValue === 'true');
  }
}

export default Vue.extend({
  name: 'CookiesAlert',
  props: {
    cookiesRulesHref: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isCookiesToAccept: getIsCookiesToAccept()
    }
  },
  methods: {
    acceptAll (): void {
      localStorage.setItem('isCookiesAccepted', 'true')
      this.isCookiesToAccept = getIsCookiesToAccept()
    }
  }
})
